import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Info } from "lucide-react";
import { colors, fonts, spacing, radius } from "../theme";

export function LegalPage({ eyebrow, title, children }) {
  const navigate = useNavigate();
  return (
    <div className="pm-fade" style={{ minHeight: "100vh", backgroundColor: colors.surface }}>
      <div style={{ paddingLeft: spacing.xl, paddingRight: spacing.xl, paddingTop: spacing.lg, paddingBottom: spacing.xxxl }}>
        <div className="pm-press" onClick={() => navigate(-1)} style={{ display: "flex", alignItems: "center", gap: 4, width: "fit-content", paddingTop: 8, paddingBottom: 8 }}>
          <ChevronLeft size={22} color={colors.onSurface} strokeWidth={2} />
          <span style={{ color: colors.onSurface, fontFamily: fonts.body, fontWeight: 500, fontSize: 14 }}>Indietro</span>
        </div>
        <div style={{ marginTop: spacing.md, marginBottom: spacing.xl }}>
          <div style={{ fontFamily: fonts.body, fontSize: 10, letterSpacing: 2, textTransform: "uppercase", color: colors.brandPrimary, fontWeight: 500 }}>{eyebrow}</div>
          <h1 style={{ marginTop: 4, marginBottom: 0, fontFamily: fonts.display, fontSize: 34, fontWeight: 700, color: colors.onSurface, letterSpacing: 0.3 }}>{title}</h1>
          <div style={{ width: 40, height: 1, backgroundColor: colors.brandPrimary, opacity: 0.7, marginTop: spacing.md }} />
        </div>
        {children}
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <div style={{ marginTop: spacing.xl }}>
      <h2 style={{ fontFamily: fonts.display, fontSize: 18, fontWeight: 700, color: colors.onSurface, letterSpacing: 0.3, marginBottom: spacing.sm, marginTop: 0 }}>{title}</h2>
      {children}
    </div>
  );
}

export function LegalParagraph({ children }) {
  return <p style={{ fontFamily: fonts.body, fontSize: 13, lineHeight: "19px", color: colors.onSurfaceSecondary, marginTop: spacing.sm, marginBottom: 0, whiteSpace: "pre-line" }}>{children}</p>;
}

export function LegalBullets({ items }) {
  return (
    <div style={{ marginTop: spacing.sm }}>
      {items.map((t, i) => (
        <div key={i} style={{ display: "flex", gap: 8, marginTop: 6, paddingLeft: 4 }}>
          <span style={{ color: colors.brandPrimary, fontFamily: fonts.body, fontWeight: 700, fontSize: 13, lineHeight: "19px" }}>•</span>
          <span style={{ flex: 1, fontFamily: fonts.body, fontSize: 13, lineHeight: "19px", color: colors.onSurfaceSecondary }}>{t}</span>
        </div>
      ))}
    </div>
  );
}

export function LegalTable({ columns, rows }) {
  return (
    <div style={{ marginTop: spacing.md, border: `0.5px solid ${colors.border}`, borderRadius: radius.md, overflow: "hidden" }}>
      <div style={{ display: "flex", borderBottom: `0.5px solid ${colors.divider}`, backgroundColor: colors.surfaceTertiary }}>
        {columns.map((c, i) => (
          <div key={i} style={{ flex: 1, paddingLeft: spacing.md, paddingRight: spacing.md, paddingTop: spacing.sm, paddingBottom: spacing.sm, fontFamily: fonts.body, fontWeight: 700, color: colors.onSurface, fontSize: 11, letterSpacing: 0.6, textTransform: "uppercase", lineHeight: "16px" }}>{c}</div>
        ))}
      </div>
      {rows.map((row, ri) => (
        <div key={ri} style={{ display: "flex", borderBottom: ri < rows.length - 1 ? `0.5px solid ${colors.divider}` : "none" }}>
          {row.map((cell, ci) => (
            <div key={ci} style={{ flex: 1, paddingLeft: spacing.md, paddingRight: spacing.md, paddingTop: spacing.sm, paddingBottom: spacing.sm, fontFamily: fonts.body, fontSize: 12, color: colors.onSurfaceSecondary, lineHeight: "16px" }}>{cell}</div>
          ))}
        </div>
      ))}
    </div>
  );
}

export function LegalCallout({ children }) {
  return (
    <div style={{ marginTop: spacing.md, display: "flex", alignItems: "flex-start", gap: 8, padding: spacing.md, border: `0.5px solid ${colors.border}`, borderRadius: radius.md, backgroundColor: "rgba(196,164,100,0.06)" }}>
      <Info size={14} color={colors.brandPrimary} strokeWidth={1.75} style={{ marginTop: 2, flexShrink: 0 }} />
      <span style={{ flex: 1, fontFamily: fonts.body, fontSize: 12, lineHeight: "17px", color: colors.onSurfaceSecondary }}>{children}</span>
    </div>
  );
}
